import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { CreateOrganisationUploadDrawer } from '@futrli/shared-services/excel-upload/excel-modals/upload/create-organisation-upload-drawer';
import { Integration } from '@futrli-sdk/app-store';
import { PREDICT_PRODUCT_ID, useModal, useWorkspaceSelector } from '@futrli/shared-services';

import { AddOrgDrawer } from '../../components/add-org-drawer/add-org-drawer';
import { useAddOrgEstimate } from '../../hooks/use-add-org-estimate/use-add-org-estimate';

interface Props {
  integrations: Integration[];
  isOpen: boolean;
  onClose: () => void;
  onExcelDrawerOpen?: () => void;
  onExcelDrawerClose?: () => void;
}

export const AddNewOrganisationContainer = ({
  integrations,
  isOpen,
  onClose,
  onExcelDrawerOpen,
  onExcelDrawerClose
}: Props) => {
  const { workspaceId: tempWorkspaceId } = useParams();
  const workspaceId = tempWorkspaceId || '';
  const workspace = useWorkspaceSelector(workspaceId);

  const excelIntegration = integrations.find(integration => integration.slug === 'excel');
  const { isLoading, estimatesText } = useAddOrgEstimate(workspace, isOpen);
  const { isOpen: isOpenExcelDialog, open: openExcelDialog, close: closeExcelDialog } = useModal();

  const handleOpenExcelDialog = useCallback(() => {
    openExcelDialog();
    onExcelDrawerOpen?.();
  }, [openExcelDialog, onExcelDrawerOpen]);

  const handleCloseExcelDialog = useCallback(() => {
    closeExcelDialog();
    onExcelDrawerClose?.();
  }, [closeExcelDialog, onExcelDrawerClose]);

  return (
    <>
      <AddOrgDrawer
        isOpen={isOpen}
        onClose={onClose}
        isLoading={isLoading}
        integrations={integrations}
        estimatesText={estimatesText}
        workspaceId={workspaceId}
        productId={PREDICT_PRODUCT_ID}
        openExcelUploadModal={handleOpenExcelDialog}
      />

      <CreateOrganisationUploadDrawer
        isOpen={isOpenExcelDialog}
        onClose={handleCloseExcelDialog}
        workspaceId={workspaceId}
        integration={excelIntegration}
      />
    </>
  );
};
